import { CountryCode } from 'common/api/crm/organization/enrollment/models';
import { EnrollSourceApplicationIds } from './RegistrationRequestWithoutOrg';
import { IS_FLIPGIVE } from 'common/env';

export interface RegistrationRequest {
    firstName: string;
    lastName: string;
    studentName: string;
    fundraisingGroup: string;
    email: string;
    password: string;
    confirmPassword: string;
    organizationId: string;
    securityQuestionAnswers: { [questionId: string]: string };
    marketingOptIn: boolean;
    blackBoxValue: string;
    username: string;
    createOneTimeCode?: boolean;
    enrollSourceApplicationId: EnrollSourceApplicationIds;
    enrollmentCode: string;
    countryCode: CountryCode;
    registrationMethod?: 'local' | 'social';
    provider?: 'google' | 'apple';
    externalRegistrationKey?: string;
    codeVerifier?: string;
    socialEmail?: string;
    emailRequired?: boolean;
}

export const emptyRegistrationRequest: RegistrationRequest = {
    firstName: '',
    lastName: '',
    studentName: '',
    fundraisingGroup: '',
    email: '',
    password: '',
    confirmPassword: '',
    organizationId: '',
    securityQuestionAnswers: {},
    marketingOptIn: !IS_FLIPGIVE,
    blackBoxValue: '',
    username: '',
    createOneTimeCode: false,
    enrollSourceApplicationId: EnrollSourceApplicationIds.V3Web,
    enrollmentCode: '',
    countryCode: 'US',
    registrationMethod: 'local',
    provider: undefined,
    externalRegistrationKey: undefined,
    codeVerifier: undefined,
    socialEmail: undefined,
    emailRequired: false,
};
